// extracted by mini-css-extract-plugin
export default {"header":"Output_header__SUhFK"};